import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PayoutPmtStatus } from "../models/payoutViewModels";


export type TPayoutView = {
  utr: string;
  debitFrom?: string;
  createdOn: string;
  purpose?: string;
  customerName?: string;
  paymentMode: string;
  amount: number;
  payoutId?: string;
  status: string;
  narration?: string;
  transactionDateTime?: string;
  vaId?: string;
  collectDesc: string;
  comments: string,
  pmtRefId: string,
}

export type TPayoutType = "PAYOUT" | "COLLECTION";
type TinitialState = {
  payout: TPayoutView;
  payoutType: TPayoutType;
  payoutStatus: PayoutPmtStatus[];
  isRefresh: boolean
};

const initialState: TinitialState = {
  payout: {
    utr: "",
    debitFrom: "",
    createdOn: "",
    purpose: "",
    customerName: "",
    paymentMode: "",
    amount: 0,
    payoutId: "",
    status: "",
    narration: "",
    transactionDateTime: "",
    vaId: "",
    collectDesc: "",
    comments: "",
    pmtRefId: ""
  },
  payoutType: "PAYOUT",
  payoutStatus: [],
  isRefresh: false
};

const payoutViewSlice = createSlice({
  name: "payoutView",
  initialState: initialState,
  reducers: {
    setPayoutViewId: (state, action: PayloadAction<{
      payoutId?: string;
      utr?: string;
      payoutType: TPayoutType;
    }>) => {
      state.payout.payoutId = action.payload.payoutId ?? '';
      state.payout.utr = action.payload.utr ?? '';
      state.payoutType = action.payload.payoutType;
    },
    setPayoutView: (state, action: PayloadAction<{
      payout: TPayoutView,
    }>) => {
      state.payout = action.payload.payout;
    },
    setPayoutStatus: (state, action: PayloadAction<PayoutPmtStatus[]>) => {
      state.payoutStatus = action.payload
    },
    setIsRefresh: (state, action: PayloadAction<boolean>) => {
      state.isRefresh = action.payload
    },
  },
});

export const {
  setPayoutView,
  setPayoutViewId,
  setPayoutStatus,
  setIsRefresh
} =
  payoutViewSlice.actions;
export default payoutViewSlice.reducer;
